import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import { PiDiscordLogo } from "react-icons/pi";
import { useLocation, useNavigate } from "react-router-dom";
import { getHost, isTokenValid } from "../utils/utils";
import Logo from "../assets/logo.svg";

const DISCORD_LOGIN_URL = `${getHost()}/api/auth/discord/login`;

export default function Login() {
  const location = useLocation();
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");
    const error = params.get("error");

    if (error === "no_access") {
      navigate("/login");
      return;
    }

    if (token) {
      localStorage.setItem("jwt", token);
      navigate("/", { replace: true });
      return;
    }
    const storedToken = localStorage.getItem("jwt");
    if (storedToken && isTokenValid(storedToken)) {
      navigate("/", { replace: true });
      return;
    }
    setChecking(false);
  }, [location, navigate]);

  if (checking) {
    return (
      <div className="bg-gradient-black vh-100 d-flex align-items-center justify-content-center text-white fw-bold fs-4">
        Redirecting...
      </div>
    );
  }

  return (
    <div className="bg-gradient-black min-vh-100 d-flex align-items-center justify-content-center">
      <div className="w-100" style={{ maxWidth: 420 }}>
        <div className="bg-white-5 p-4 rounded-3 shadow-lg">
          <div className="d-flex align-items-center gap-3 mb-4">
            <img
              src={Logo}
              alt="Logo"
              style={{
                width: 48,
                height: 48,
                borderRadius: 12,
                background: "#222",
              }}
            />
            <div>
              <h2 className="text-white fw-700 fs-24 mb-0">Welcome to TSB</h2>
              <div className="text-white-65 fs-14 fw-500">
                Please sign in to continue
              </div>
            </div>
          </div>

          <Button
            onClick={() => {
              window.location.href = DISCORD_LOGIN_URL;
            }}
            variant=""
            className="w-100 d-flex align-items-center justify-content-center gap-2 py-2 mb-3 bg-discord text-white rounded-3 shadow-sm fs-16 fw-600"
            style={{ background: "#5865F2" }}
          >
            <PiDiscordLogo style={{ fontSize: 22 }} />
            Login with Discord
          </Button>

          <div className="text-white-45 fs-13 text-center">
            By logging in, you agree to our{" "}
            <a
              href="https://www.thescrapingbook.com/"
              className="text-gray text-decoration-underline"
            >
              Terms of Service
            </a>
            .
          </div>
        </div>
      </div>
      <div
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          height: "200px",
          background: "linear-gradient(90deg, #00E98E 0%, #5865F2 100%)",
          opacity: 0.08,
          zIndex: -1,
        }}
      />
    </div>
  );
}
